import { FunctionComponent, ReactNode } from "react";
import { useIntl } from "react-intl";
import Link from "@Components/atoms/Link";
import "./style.scss";

interface Props {
  disabled: boolean;
  editable: boolean;
  icon: JSX.Element;
  onEdit: () => void;
  title: ReactNode;
}

const CheckoutStepHeader: FunctionComponent<Props> = ({
  disabled,
  editable,
  icon,
  onEdit,
  title,
}) => {
  const intl = useIntl();

  return (
    <div className="CheckoutStepHeader">
      <div className="CheckoutStepHeader-title">
        {icon}
        {title}
      </div>
      {editable && (
        <Link disabled={disabled} onClick={onEdit} size="m">
          {intl.formatMessage({
            id: "cheerz_Drafts_edit_button",
          })}
        </Link>
      )}
    </div>
  );
};

export default CheckoutStepHeader;
